import { tv, type VariantProps } from 'tailwind-variants';

const stackVariants = tv({
  base: 'flex',
  variants: {
    direction: {
      row: 'flex-row items-center',
      col: 'flex-col',
    },
    gap: {
      0: 'gap-0',
      1: 'gap-1',
      2: 'gap-2',
      3: 'gap-3',
      4: 'gap-4',
      5: 'gap-5',
      6: 'gap-6',
      7: 'gap-7',
      8: 'gap-8',
      9: 'gap-9',
      10: 'gap-10',
    },
  },
  defaultVariants: {
    direction: 'col',
    gap: 0,
  },
});

type StackVariants = VariantProps<typeof stackVariants>;

interface StackProps<T extends React.ElementType> extends StackVariants {
  as?: T;
  children?: React.ReactNode;
}

export function Stack<T extends React.ElementType = 'div'>({
  as,
  children,
  className,
  gap,
  direction,
  ...props
}: StackProps<T> & Omit<React.ComponentPropsWithoutRef<T>, keyof StackProps<T>>): JSX.Element {
  const Component = as || 'div';

  return (
    <Component className={stackVariants({ gap, direction, className })} {...props}>
      {children}
    </Component>
  );
}
